import { TidingsClientBase } from './tidingsClientBase';

export default class TidingsClient extends TidingsClientBase {

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/Tidings/tidingsClient.ts